import JSTracker from './JSTracker';

export default function dspJsTracker(reactDirective, CreativeService) {
  return reactDirective(
    JSTracker,
    undefined,
    { restrict: 'E' },
    { CreativeService }
  );
}

dspJsTracker.$inject = ['reactDirective', 'CreativeService'];
